<template>
  <div>
    <v-dialog
      v-model="dialogFeatureSearch"
      max-width="1000px"
      content-class="company-job-info__dialog"
      persistent
    >
      <div class="dialog-checkbox">
        <div class="dialog-checkbox__dialog__container">
          <div class="dialog-checkbox__dialog__header">
            <v-checkbox v-model="featureSearch.allSelected" @change="selectAll" label="全選択"></v-checkbox>
          </div>
          <div class="dialog-checkbox__dialog__form-container">
            <v-row column class="mb-3" v-for="(items, index) in data" :key="index">
              <v-col cols="12" sm="12" md="12" lg="12" class="dialog-checkbox__dialog__sub-header">
                <v-subheader>{{items.name}}</v-subheader>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" class="mt-2 mb-2">
                <v-row row wrap>
                  <v-col
                    cols="12"
                    sm="4"
                    md="4"
                    lg="4"
                    v-for="(item) in items.item"
                    :key="item.small_code"
                  >
                    <v-checkbox
                      v-model="featureSearch.selected"
                      @change="select"
                      :label="item.small_name"
                      :value="item"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="company-side-detail__btn-dialog btn-component -red mt-3 mb-3">
          <v-btn @click="closeDialogFeatureSearch">
            <span>選択する</span>
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyRecruitmentKey from "@/components/company-recruitment-key";

export default createComponent( {

   setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const companyRecruitment = inject(CompanyRecruitmentKey);
    if (!companyRecruitment) {
      throw new Error(`${CompanyRecruitmentKey} is not provided`);
    }
    const data = computed(() => companyRecruitment.featureSearch.data)
    const featureSearch = computed(() => companyRecruitment.featureSearch);
    const selectAll = computed(() => companyRecruitment.featureSelectAll);
    const select = computed(() => companyRecruitment.featureSelect);
    const dialogFeatureSearch = computed(() => displayui.dialogFeatureSearch);
    const closeDialogFeatureSearch = computed(() => displayui.closeFeatureSearchDialog);
    return {
      featureSearch,
      selectAll,
      select,
      data,
      dialogFeatureSearch,
      closeDialogFeatureSearch
    };
  },
}
)
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
@import "@/assets/scss/layout/company/company-detail.scss";
@import "@/assets/scss/layout/company/company-job-infor.scss";
@import "@/assets/scss/layout/company/job-type.scss";
</style>
